<template>
  <div>
    <catalog-select
      ref="catalog_select"
      catalog-name="должность"
      :is-disabled="isDisabled"
      :state="state"
      :initial-value="value"
      :get-item-by-id="getJobTitle"
      :get-list="getItems"
      :can-create-catalog="canCreateJobTitle()"
      @onSelect="$emit('onSelect', $event)"
      @open-modal="isModalVisible = true"
    />

    <job-title
      v-if="isModalVisible"
      :create-id="0"
      @modal-closed="isModalVisible = false"
      @refresh="onCatalogItemCreated"
    />
  </div>
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import JobTitle from "./JobTitle.vue";
    import CatalogSelect from "../CatalogSelect.vue";

export default {
  name: "JobTitleSelect",
  components: { JobTitle, CatalogSelect },
  mixins: [
    catalogs,
    permissions,
  ],
  props: {
    isDisabled: { type: Boolean, default: null },
    state: { type: Boolean, default: null },
    value: { type: Number, default: null },
  },
  data() {
    return {
      isModalVisible: false
    }
  },
  methods: {
    async getItems() {
      const result = await this.getJobTitlesSearch('');
      return (result && result.data) ? result.data : [];
    },
    async getJobTitle(id) {
      const result = await this.getJobTitleById(id);
      return (result && result.data) ? result.data : null;
    },
    async onCatalogItemCreated(newItem) {
      this.$refs.catalog_select.onItemCreated(newItem);
      this.isModalVisible = false;
    },
    // Permissions
    canCreateJobTitle() {
      return this.hasPermission([PERM.CATALOG_JOB_TITLE_EDIT]);
    }
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/JobTitles/JobTitleSelect.vue